export enum Status {
  NEEDS_REVIEW = 'Needs Review',
  COMPLETE = 'Complete',
  NOTHING = '',
  NA = 'N/A',
}

export enum MortgageType {
  FHA = 'FHA',
  VA = 'VA',
}

export enum VAOccupancyType {
  NotAssigned = 'NotAssigned',
  CurrentOccupant = 'CurrentOccupant',
  SpouseIsVeteranAndWillOccupy = 'SpouseIsVeteranAndWillOccupy',
  PreviousOccupant = 'PreviousOccupant',
  SpouseIsVeteranAndPrevOccupant = 'SpouseIsVeteranAndPrevOccupant',
  ChildWillOccupy = 'ChildWillOccupy',
  ChildOccupiedIRRL = 'ChildOccupiedIRRL',
}

export enum FHAReasonableValueType {
  NotAssigned = 'NotAssigned',
  DeterminedByVA = 'DeterminedByVA',
  DeterminedByFHA = 'DeterminedByFHA',
}

export enum PriceExceedingValueAwareness {
  NotAssigned = 'NotAssigned',
  AwareAtSigning = 'AwareAtSigning',
  NotAwareAtSigning = 'NotAwareAtSigning',
}

export enum LoanPurpose {
  Purchase = 'Purchase',
  Refinance = 'Refinance',
  RefiSecond = 'RefiSecond',
  RefiThird = 'RefiThird',
}
